import React from 'react';
import './Calculator.css';

class Display extends React.Component {

    render() {
        return (
            <div className="calc-display">
                <div>{this.props.value}</div>
            </div>
        )
    }
}

export default Display;